import { render, staticRenderFns } from "./StepBankLoading.vue?vue&type=template&id=2f7d1924&scoped=true"
import script from "./StepBankLoading.vue?vue&type=script&lang=js"
export * from "./StepBankLoading.vue?vue&type=script&lang=js"
import style0 from "./StepBankLoading.vue?vue&type=style&index=0&id=2f7d1924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7d1924",
  null
  
)

export default component.exports